import SocialShare from "@/components/common/SocialShare";
import useDates from "@/hooks/useDates";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Popover,
  Typography,
} from "@repo/ui";
import {
  UserOutlined,
  TimeIcon,
  ShareIcon,
  CalendarIcon,
} from "@spoctech/icons";
import Image from "next/image";
import Link from "next/link";

interface WebinarCardProps {
  coverSrc?: string;
  tag?: string;
  title: string;
  author?: string;
  date?: string;
  time?: string;
  pageSlug?: string;
  eventDates: string[];
}
const WebinarCard = ({
  coverSrc,
  tag,
  title,
  author,
  time,
  pageSlug,
  eventDates,
}: WebinarCardProps) => {
  const { formattedDate } = useDates(eventDates);
  return (
    <Card outlined className="relative h-full flex flex-col justify-between">
      {coverSrc && (
        <div className="relative">
          <CardMedia
            render={
              <Image
                src={coverSrc}
                alt={title}
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                className="object-cover rounded-t-lg  !relative aspect-video"
                quality={100}
              />
            }
          />
        </div>
      )}
      <CardContent className="flex-1">
        {Boolean(tag) && (
          <Box className="absolute top-2 left-2">
            <Chip
              label={tag ?? ""}
              size="medium"
              className="rounded-full text-base  !px-6 !bg-white !text-black"
            />
          </Box>
        )}
        <Typography
          variant="h4"
          render={<div />}
          className="!font-bold tracking-wide"
          gutterBottom
        >
          {title}
        </Typography>
        <Box className="py-5">
          <ul>
            <li className="flex gap-2 items-center pb-2">
              <CalendarIcon
                className="!text-primary-main"
                width={20}
                height={20}
              />
              {formattedDate}
            </li>
            <li className="flex gap-2 items-center pb-2">
              <TimeIcon className="!text-primary-main" width={20} height={20} />
              {time}
            </li>
            <li className="flex gap-2 items-center">
              <UserOutlined
                className="!text-primary-main"
                width={20}
                height={20}
              />
              {author}
            </li>
          </ul>
        </Box>
      </CardContent>
      <CardActions>
        <Box flex justifyContent="between" className="gap-x-3">
          <Box>
            <Popover
              side="right"
              disabled={!pageSlug}
              trigger={
                <Button
                  variant="outlined"
                  color="secondary"
                  aria-label="share"
                  icon={<ShareIcon />}
                />
              }
            >
              <SocialShare
                url={`${process.env.NEXT_PUBLIC_APP_URL}/webinar/${pageSlug}`}
                title={title}
              />
            </Popover>
          </Box>
          <Box className="flex-1">
            <Button
              variant="contained"
              color="primary"
              fullWidth
              render={
                pageSlug ? <Link href={`/webinar/${pageSlug}`} /> : <button />
              }
              disabled={!pageSlug}
            >
              Explore Webinar
            </Button>
          </Box>
        </Box>
      </CardActions>
    </Card>
  );
};

export default WebinarCard;
